import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StoreState } from "./store";
import { Project, Punch, Work } from "../service/backend-service";

let initialState: {
    projects: Array<Project>,
    workSet: Array<Work>
} = {
    projects: [],
    workSet: []
};

let projectSorter = ((a: Project, b: Project) => {
        if (b.favorite && !a.favorite) {
            return 1;
        } else if (a.favorite && !b.favorite) {
            return -1;
        } else {
            return a.name.localeCompare(b.name);
        }
    });

export const core = createSlice({
    name: 'core',
    initialState: initialState,
    reducers: {
        addProject: (state, action: PayloadAction<Project>) => {
            state.projects.unshift(action.payload);
        },
        removeProject: (state, action: PayloadAction<number>) => {
            state.projects = state.projects.filter(project => project.id !== action.payload);
        },
        updateProject: (state, action: PayloadAction<{id: number, project: Project}>) => {
            state.projects = state.projects
                .map(project => project.id !== action.payload.id ? project : action.payload.project)
                .sort(projectSorter);
        },
        setProjects: (state, action: PayloadAction<Array<Project>>) => {
            state.projects = action.payload;
        },
        setWorkSet: (state, action: PayloadAction<Array<Work>>) => {
            state.workSet = action.payload;
        },
        updateWork: (state, action: PayloadAction<{projectId: number, openPunch?: Punch}>) => {
            state.workSet = state.workSet.map(work => work.project.id !== action.payload.projectId ? work : {
                project: work.project,
                activeSprints: work.activeSprints,
                openPunch: action.payload.openPunch
            });
        },
        addWorkSprints: (state, action: PayloadAction<{projectId: number, newSprint: number}>) => {
            
            state.workSet = state.workSet.map(work => {
                if (work.project.id !== action.payload.projectId) {
                    return work;
                } else {
                    let newSprints = work.activeSprints.slice()
                    newSprints.push(action.payload.newSprint)
                    return {
                        ...work,
                        activeSprints: newSprints
                    };
                }
            });
        }
    } 
});

export const {
    addProject,
    updateProject,
    removeProject,
    setProjects,
    setWorkSet,
    updateWork,
    addWorkSprints
} = core.actions;

export const getProjects = (state: StoreState) => state.core.projects;
export const getWorkSet = (state: StoreState) => state.core.workSet;

export default core.reducer;